/**
 * @license
 * Copyright (c) 2020 ForgeRock. All rights reserved.
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */

import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: () => {
        /* Detect if a query string suspendedId is present.  If so, this is a User Registration flow that should be redirected to
        the AM instance domain name so that WebAuthn RpId can be set appropriately.  Ie. if sso7tst.richmond.ca, then redirect to
        login7tst.richmond.ca/login */
        const urlParams = new URLSearchParams(window.location.search);
        const authIndexValue = urlParams.get('suspendedId');
        if (window.location.hostname.startsWith('sso')) {
          // origin includes scheme, hostname, and port.
          // pathname is at least a '/' even if it is not specified in the URL
          // search is prefixed with a "?" if non-empty, and must precedes hash
          // hash is prefixed with a "#" if non-empty
          let origin = window.location.origin.replace('sso', 'login');
          let pathname = '/login' + window.location.pathname; // the AM login page is at context path /login/ (this is due to the k8s ingress setup by FR)
          window.location.replace(origin+pathname+window.location.search+window.location.hash);
        }

        return import('@/views/Login');

        /* Example to import/render different view
        const urlParams = new URLSearchParams(window.location.search);
        const authIndexValue = urlParams.get('authIndexValue');
        if ((authIndexValue == 'CORPlatformRegistration')||(authIndexValue == 'CORPlatformRegistration2')||(authIndexValue == 'CORPlatformRegistrationMobile'))

          return import('@/views/Registration');
        else
          return import('@/views/Login');
        */
      }
    },
    {
      path: '/logout',
      name: 'logout',
    },
    {
      path: '/service/:tree',
      name: 'service',
      component: () => import('@/views/Login'),
    },
    {
      path: '/registered',
      name: 'registered',
      component: () => import('@/views/Registered')
    },
    {
      path: '/resetdone',
      name: 'resetdone',
      component: () => import('@/views/ResetDone')
    },
    {
      path: '/testuniversal',
      name: 'testuniversal',
      component: () => import('@/views/TestUniversal')
    },
    {
      // send any bad routes to default login
      path: '*',
      redirect: '/',
    },
  ],
  mode: 'hash' // use hash in URL (https://v3.router.vuejs.org/api/#mode) since required by FR OOTB
});
